import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    fontSize: '0.625rem',
    fontWeight: 600,
    color: theme.palette.secondary[900],
    marginTop: '1rem',
    display: 'block',
  },
});

const Label = ({ classes, children }) => (
  // eslint-disable-next-line jsx-a11y/label-has-for
  <label className={classes.root}>{children}</label>
);

Label.propTypes = {
  classes: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(Label);
